<voxel-container-md *ngIf="CONTENT_BOUNDS">
  <app-header (closeEvent)="onCloseEvent($event)">
  </app-header>
  <div class="voxel-container-md container-padding">

    <app-stepper 
        *ngIf="CONTENT_BOUNDS && stepsList && stepsList.length > 0" 
        [title]="CONTENT_BOUNDS?.title" 
        [currentStep]="2" 
        [stepsList]="stepsList" 
        [labelName]="CONTENT_BOUNDS?.name" 
        [labelStep]="CONTENT_BOUNDS?.step">
    </app-stepper> 

      <div class="container-data">

        <ng-container *ngIf="showErrorMessage">
            <div class="voxel-col-12">
              <voxel-alert [type]="CONTENT_BOUNDS?.error_notification?.type" light class="voxel-mb-2"
                [icon]="CONTENT_BOUNDS?.error_notification?.icon">
                {{this.CONTENT_BOUNDS?.error_notification?.text}}
    
                <button voxelButtonAction (click)="navigateTo('next')">
                  {{this.CONTENT_BOUNDS?.error_notification?.link?.label}}
                </button>
              </voxel-alert>
            </div>
        </ng-container>

            <app-solicitation-modal-typification #modalTypification [formGroup]="additionalDataForm" [componentStart]="false"></app-solicitation-modal-typification>

            <div class="voxel-row">
                <p class="voxel-col-12 voxel-pv-2">{{CONTENT_BOUNDS.caption_main}}</p>
            </div>
            <app-form-solicitation-additional-data #formAdditionalData [formGroup]="additionalDataForm" [data]="solicitationData?.additionalData"></app-form-solicitation-additional-data>

            <voxel-loading-circle *ngIf="isLoading" class="loading" [loadingTitle]="CONTENT_BOUNDS?.load_text"></voxel-loading-circle>
    </div>

      <div class="actions" *ngIf="form">
          <div class="voxel-row">
              <button
                  [disabled]="isLoading"
                  voxelButton
                  buttonStyle=secondary
                  (click)="navigateTo('previous')"
                  class="voxel-col-12 voxel-col-xs-2 voxel-col-offset-sm-2 voxel-col-sm-3 voxel-col-offset-md-3 voxel-col-md-4">
                  {{CONTENT_BOUNDS?.buttons?.secondary_button?.caption}}
              </button>

              <button
                  *ngIf="form"
                  voxelButton
                  (click)="navigateTo('next')"
                  class="voxel-col-12 voxel-col-xs-2 voxel-col-sm-3 voxel-col-md-4"
                  [disabled]="!form.valid || isLoading">
                  {{CONTENT_BOUNDS?.buttons?.primary_button?.caption}}
              </button>

          </div>
      </div>
  </div>

  <button #defaultOriginDialogButtons="voxelOverlayOrigin" voxelOverlayOrigin class="no-visible"></button>

  <voxel-dialog [dialogOrigin]="defaultOriginDialogButtons" [id]="'dialog-b'" [buttonAlignment]="'horizontal'"
    [dialogIsOpen]="showDialogConfirm" (dialogClose)="dialogButtonClicked({type:''})">
    <p>Has terminado de diligenciar la información.</p>
    <p>¿Deseas radicar tu solicitud?</p>

    <div voxelDialogFooter>
      <button voxelButtonContextual (click)="dialogButtonClicked({type:'action1'})">
        Cancelar
      </button>
      <button voxelButtonContextual (click)="dialogButtonClicked({type:'action2'})">
        Aceptar
      </button>
    </div>

  </voxel-dialog>


<voxel-container-md>
